import { render, staticRenderFns } from "./MandateAccount.vue?vue&type=template&id=07389696&scoped=true&"
import script from "./MandateAccount.vue?vue&type=script&lang=js&"
export * from "./MandateAccount.vue?vue&type=script&lang=js&"
import style0 from "./MandateAccount.vue?vue&type=style&index=0&id=07389696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07389696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/ubq-h5_build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07389696')) {
      api.createRecord('07389696', component.options)
    } else {
      api.reload('07389696', component.options)
    }
    module.hot.accept("./MandateAccount.vue?vue&type=template&id=07389696&scoped=true&", function () {
      api.rerender('07389696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MandateAccount.vue"
export default component.exports